<template>
  <div>
    <div class="contract">
      <Header
        v-if="!checkCreatedDateNganluong(dataAppendix)"
        :groupService="dataContract.groupService"
      ></Header>
      <HeaderNL v-else :groupService="dataContract.groupService"></HeaderNL>
      <p class="txt-center fonsize-16 txt-tranf">CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM</p>
      <p class="txt-center fonsize-16">Độc lập – Tự do – Hạnh phúc</p>
      <p class="txt-center fonsize-16">***</p>
      <p class="txt-tranf txt-center fonsize-20 magb20">
        <b
          >PHỤ LỤC<br />
          BIỂU PHÍ VÀ NGUYÊN TẮC CHẤP NHẬN THANH TOÁN
        </b>
      </p>
      <p class="txt-center">
        (PLBPTT:
        <mark>{{ dataAppendix.code }}</mark>
        )
      </p>
      <p>Căn cứ:</p>
      <ol class="form-style2">
        <li>
          <span>
            Hợp đồng hợp tác chấp nhận thanh toán thẻ số
            <mark>{{ dataContract.code }}</mark>
          </span>
          <p class="magt10">
            (sau đây được viết tắt là “Hợp đồng”) ký ngày
            <mark>
              {{
                dataContract.effectiveFromDTO
                  ? dataContract.effectiveFromDTO
                  : dataContract.dateSign | formatDate
              }}</mark
            >
          </p>
        </li>
        <li>Nhu cầu và khả năng của hai Bên.</li>
      </ol>
      <p>
        Hôm nay, ngày
        <mark v-if="dataAppendix.dateSignAppendixDTO">{{
          dataAppendix.dateSignAppendixDTO | formatDate
        }}</mark>
        <mark v-else-if="dataAppendix.dateCreatedAppendixDTO">{{
          dataAppendix.dateCreatedAppendixDTO | formatDate
        }}</mark>
        <mark v-else-if="dataContract.effectiveFromDTO">{{
          dataContract.effectiveFromDTO | formatDate
        }}</mark>
        ,
        {{
          checkCreatedDateNganluong(dataAppendix)
            ? 'tại trụ sở Công ty Cổ phần cổng trung gian thanh toán Ngân Lượng, chúng tôi gồm có:'
            : 'tại trụ sở Công ty Cổ phần Công nghệ Vi Mô, chúng tôi gồm có:'
        }}
      </p>
      <p class="fonsize-16 txt-tranf flex">
        <b v-if="!checkCreatedDateNganluong(dataAppendix)"
          >BÊN A: CÔNG TY CỔ PHẦN CÔNG NGHỆ VI MÔ</b
        >
        <b v-else>BÊN A: CÔNG TY CỔ PHẦN CỔNG TRUNG GIAN THANH TOÁN NGÂN LƯỢNG</b>
      </p>
      <p v-if="checkCreatedDateNganluong(dataAppendix)">
        Trụ sở: Tầng 3, tòa nhà VTC online, số 18 đường Tam Trinh, phường Tương Mai, thành phố Hà
        Nội, Việt Nam.
      </p>
      <p v-else>
        Trụ sở: Tầng 12A, tòa nhà VTC online, số 18 đường Tam Trinh, phường Tương Mai, thành phố Hà
        Nội, Việt Nam.
      </p>
      <div class="form form-ext">
        <p>
          Điện thoại: 024 36320986
          <span class="ml-4" v-if="!checkCreatedDateNganluong(dataAppendix)"
            >Fax: 024 36320987</span
          >
        </p>
        <p v-if="!checkCreatedDateNganluong(dataAppendix)">Tài khoản: 11001010157634</p>
        <p v-if="!checkCreatedDateNganluong(dataAppendix)">Tại: Ngân hàng Maritimebank</p>
        <p v-if="checkCreatedDateNganluong(dataAppendix)">Mã số thuế: 0106001236</p>
        <p v-else>Mã số thuế: 0106393463</p>
        <p>
          Người đại diện:
          <b
            v-if="
              dataAppendix?.dateSignAppendixDTO ||
              dataAppendix?.dateCreatedAppendixDTO ||
              dataContract?.effectiveFromDTO
                ? (dataAppendix?.dateSignAppendixDTO ||
                    dataAppendix?.dateCreatedAppendixDTO ||
                    dataContract?.effectiveFromDTO) < new Date('2026-01-07').getTime()
                : new Date() < new Date('2026-01-07')
            "
            >ĐỖ CÔNG DIỄN</b
          >
          <b v-else>Ông NGUYỄN TIẾN LƯỢNG</b>
          <span class="ml-4"
            >Chức vụ: <b v-if="!checkCreatedDateNganluong(dataAppendix)">Tổng Giám Đốc</b
            ><b v-else>Phó Tổng Giám đốc kiêm Giám đốc BU Chuyển đổi số</b></span
          >
        </p>
        <p v-if="checkCreatedDateNganluong(dataAppendix)">
          Giấy ủy quyền số: 1302/2026/GUQ/NGANLUONG ngày 13/02/2026
        </p>
        <p>
          NVKD:
          <b>{{
            dataContract.saleInfoRes && dataContract.saleInfoRes.name
              ? dataContract.saleInfoRes.name
              : ''
          }}</b>
          <span class="ml-4">Điện thoại:</span>
          <b>{{
            dataContract.saleInfoRes && dataContract.saleInfoRes.mobile
              ? dataContract.saleInfoRes.mobile
              : ''
          }}</b>
        </p>
      </div>
      <p>và</p>
      <p class="fonsize-16 txt-tranf flex">
        <span class="nowrap"> <b>BÊN B:</b></span>
        <mark>
          <b>{{ customerInfo.merchantName }}</b>
        </mark>
      </p>
      <div class="form form-ext">
        <p>
          <span>Trụ sở: </span>
          <mark>
            {{ customerInfo.address }}
            <!-- ,{{ customerInfo.district }},
            {{ customerInfo.city }} -->
          </mark>
        </p>
        <p>
          Website:<mark v-if="customerInfo.website"> {{ customerInfo.website }}</mark>
        </p>
        <p>
          <span>Điện thoại:</span><mark>{{ customerInfo.mobile }}</mark>
          <span class="ml-4"> Fax: </span>
        </p>
        <p>
          Tài khoản:<mark> {{ customerInfo.accountNo }}</mark>
        </p>
        <p>
          Tại:<mark> {{ customerInfo.bankName }}</mark>
        </p>
        <p>
          <span>Mã số thuế:</span>
          <mark>
            {{ customerInfo.businessRegistrationNumber }}
          </mark>
        </p>
        <p>
          <span>Họ và tên người đại diện: </span
          ><mark
            ><b>{{ customerInfo.customerName }}</b></mark
          >
          <span class="ml-4"
            >Chức vụ: <mark v-if="customerInfo.position"> {{ customerInfo.position }}</mark></span
          >
        </p>
      </div>

      <p>Cùng thỏa thuận hợp tác và cam kết thực hiện những điều sau đây:</p>

      <ol class="form-style1">
        <li v-if="existOnlyVietQr || existOnlyCard">
          <h1>ĐỊNH NGHĨA</h1>
          <ul>
            <li>
              <strong> "Ghi có"</strong> là nghiệp vụ kế toán trong lĩnh vực thanh toán ngân hàng,
              thể hiện việc tăng số dư tài khoản của Bên B khi có khoản tiền được chuyển vào. Ngân
              hàng/ Bên A sẽ thực hiện ghi có số tiền tương ứng vào tài khoản của Bên B khi có giao
              dịch phát sinh theo thỏa thuận giữa các Bên.
            </li>
            <li>
              <strong> “Hình thức nhận thanh toán trực tiếp”:</strong> là phương thức mà Bên B nhận
              tiền thanh toán từ Khách hàng ngay tại điểm chấp nhận thanh toán thông qua việc quét
              mã QR do Bên A cung cấp. Khi Khách hàng thực hiện quét mã QR và thanh toán, số tiền
              giao dịch sẽ được chuyển trực tiếp vào tài khoản ngân hàng nhận thanh toán của Bên B
              theo thỏa thuận giữa hai Bên.
            </li>
            <li>
              <strong> “Hình thức nhận thanh toán gián tiếp”:</strong> là phương thức mà Bên B nhận
              tiền thanh toán từ Khách hàng thông qua hệ thống của Bên A. Khi Khách hàng quét mã QR
              tại điểm chấp nhận thanh toán của Bên B và thực hiện thanh toán, số tiền giao dịch sẽ
              được xử lý bởi Bên A trước khi được chuyển vào tài khoản nhận thanh toán của Bên B
              theo thời gian và điều kiện quy định tại Hợp đồng.
            </li>
          </ul>
        </li>

        <li>
          <h1>PHÍ GIAO DỊCH</h1>
          <table class="magb20">
            <thead>
              <tr class="bg-head1">
                <th style="width: 50px"><b>STT</b></th>
                <th><b>Loại thẻ/Phương thức thanh toán</b></th>
                <th><b>Mức phí</b></th>
                <th><b>Ghi Chú</b></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in filteredItems" :key="index">
                <td class="txt-center">{{ index + 1 }}</td>
                <td>{{ item.issuerName }}/{{ item.paymentMethod }}</td>
                <td class="txt-center">
                  <mark v-if="item.isDefaultFee === false"
                    ><b>{{ item.feePerTransaction }} %</b></mark
                  >
                  <b v-else>{{ item.feePerTransaction }} %</b>
                </td>
                <td>{{ item.note ?? '' }}</td>
              </tr>
            </tbody>
          </table>
          <p><b>Lưu ý: </b></p>
          <ol class="form-style2">
            <li><i>Đơn vị tính là VNĐ và đã bao gồm VAT.</i></li>
            <li>
              <i>Biểu phí này căn cứ theo chính sách của Bên A được ban hành tại từng thời điểm.</i>
            </li>
          </ol>
        </li>
        <li>
          <h1>NGUYÊN TẮC CHẤP NHẬN THANH TOÁN</h1>
          <ul v-if="!existOnlyVietQr">
            <li>
              Loại thẻ hỗ trợ thanh toán là thẻ mang thương hiệu Visa, Master hoặc JCB/CUP và DCI
              hoặc thẻ nội địa ATM/ Napas, Thẻ Tín dụng nội địa (thương hiệu Napas)..
            </li>
            <li>
              Các loại giao dịch QR được hỗ trợ, bao gồm: QRCode Ngân hàng, Techcombank, ví
              ViettelQR, ví VinID, ví VIMO, ví SHOPEE-PAY, ví SMARTPAY, ví ZaloPay, VietQR, mVisa,
              MasterPass.
            </li>
            <li>
              Loại thẻ và QRCode có thể được bổ sung/ thay đổi trong tương lai, khi có sự bổ sung/
              thay đổi, Bên A sẽ thông báo cho Bên B bằng email hoặc bằng văn bản.
            </li>
            <li>
              Chỉ có các giao dịch khách hàng đã thanh toán và được ghi nhận thành công trên hệ
              thống ứng dụng dành cho điểm bán hàng của Bên A mới được tiến hành đối soát và thanh
              toán.
            </li>
            <li>
              Bên B chỉ được phép chấp nhận các giao dịch thanh toán được thực hiện trên lãnh thổ
              Việt Nam, tuân thủ quy định của Pháp luật, thực hiện đầy đủ các thủ tục xin cấp
              phép/thông báo/đăng ký trong quá trình hoạt động kinh doanh với cơ quan nhà nước có
              thẩm quyền.
            </li>
            <li>
              Các chính sách, quy định áp dụng riêng với phương thức thanh toán VietQR:
              <ul class="form-style2">
                <li>
                  Hình thức nhận thanh toán trực tiếp về số tài khoản Ngân hàng của Bên B
                  <ul class="form-style2">
                    <li>
                      Sau khi giao dịch được xử lý thành công, số tiền thanh toán sẽ được ghi có
                      trực tiếp về số tài khoản Ngân hàng của Bên B đã khai báo và liên kết thông
                      báo trên ứng dụng của Bên A.
                    </li>
                    <li>
                      Bên B đăng nhập vào tài khoản ngân hàng của mình theo dõi biến động số dư hoặc
                      vào ứng dụng Tingbox.vn để theo dõi giao dịch.
                    </li>
                    <li>
                      Hình thức chỉ áp dụng đối với giao dịch VietQR trên ứng dụng Tingbox.vn.
                    </li>
                    <li>
                      Bên A sẽ không tiến hành thanh toán bất cứ khoản tiền nào cho Bên B khi chọn
                      hình thức nhận tiền thanh toán trực tiếp về tài khoản Ngân hàng của Bên B.
                    </li>
                  </ul>
                </li>
                <li>
                  Hình thức nhận thanh toán gián tiếp qua hệ thống của Bên A
                  <ul class="form-style2">
                    <li>
                      Sau khi giao dịch được xử lý thành công trên hệ thống của Bên A, Bên A sẽ tiến
                      hành thanh toán đến Bên B bằng hình thức chuyển khoản tới số tài khoản Ngân
                      hàng của Bên B đã khai báo với Bên A.
                    </li>
                  </ul>
                </li>
                <li>
                  Chu kì thanh toán tiền mặc định: Gọi T là ngày Bên B thực hiện giao dịch VietQR,
                  thì:
                  <ul class="form-style2">
                    <li>
                      Đối với các giao dịch của Bên B phát sinh trên hệ thống của Bên A từ thứ 2 đến
                      thứ 6: thanh toán tiền vào ngày T+1
                    </li>
                    <li>
                      Đối với các giao dịch của Bên B phát sinh trên hệ thống của Bên A vào thứ 7 và
                      Chủ nhật: thanh toán tiền vào ngày thứ 2 của tuần kế tiếp.
                    </li>
                  </ul>
                </li>
                <li>
                  Chính sách nhận tiền nhanh về tài khoản ngân hàng:
                  <ul class="form-style2">
                    <li>
                      Phạm vi áp dụng: Tính năng nhận tiền nhanh cho phép Bên B đặt tối đa 04 (bốn)
                      yêu cầu nhận tiền nhanh mỗi ngày, với tổng số tiền không vượt quá 100.000.000
                      VNĐ/ngày/tài khoản. Số tiền giao dịch còn lại trong ngày (nếu có) sẽ được Bên
                      A thanh toán vào ngày T+1.
                      <ul class="form-style2">
                        <!-- <li>Bên B có tổng doanh số thanh toán kênh VietQR <= <b>1.000.000.000VNĐ/ tháng</b>
                            (chu kỳ một tháng được tính theo thời gian từ ngày 25 tháng trước đến ngày 24 tháng
                            sau) tính đến thời điểm đặt lệnh nhận tiền nhanh.</li> -->
                        <!-- <li>
                          Bên B chỉ được đặt lệnh nhận tiền nhanh không quá
                          <b>04 (bốn)</b> yêu cầu/ngày và tổng số tiền nhận
                          nhanh không quá <b>100.000.000VNĐ/ ngày</b>. Số tiền
                          giao dịch còn lại trong ngày của Bên B (nếu có) sẽ
                          được Bên A thanh toán vào ngày T+1.
                        </li> -->
                      </ul>
                    </li>
                    <li>
                      Hình thức đặt lệnh nhận tiền nhanh: Bên B phải cài đặt và đặt lệnh yêu cầu rút
                      tiền nhanh trên ứng dụng mPOS360 (Ứng dụng chuyên dùng cho chủ cửa hàng của
                      Bên A)
                    </li>
                    <li>
                      <p>
                        Khung giờ đặt lệnh Nhận tiền nhanh và thời gian nhận tiền tương ứng như sau:
                      </p>
                      <br />
                      <div class="table-responsive">
                        <table>
                          <thead>
                            <tr class="bg-head">
                              <th class="text-center"><b>Ngày hỗ trợ</b></th>
                              <th class="text-center">
                                <b>Khung giờ đặt lệnh</b>
                              </th>
                              <th class="text-center">
                                <b>Thời gian nhận tiền</b>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr class="text-center">
                              <td rowspan="2" class="text-center">Tất cả ngày trong tuần</td>
                              <td class="text-center">Từ 8h30 đến 21h00</td>
                              <td class="text-center">Trong vòng 10 phút kể từ khi đặt lệnh</td>
                            </tr>
                            <tr class="text-center">
                              <td class="text-center">Sau 21h00</td>
                              <td class="text-center">Từ 8h30 sáng ngày hôm sau</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </li>
                  </ul>
                </li>
                <li>
                  Tại bất kỳ thời điểm nào, Bên B chỉ được lựa chọn và sử dụng một phương thức nhận
                  thanh toán. Việc thay đổi phương thức nhận thanh toán phải tuân thủ theo điều kiện
                  và quy trình do Bên A quy định.
                </li>
                <li>
                  Bên B có trách nhiệm chủ động thiết lập và đăng ký phương thức nhận tiền thông qua
                  tài khoản của Bên B trên ứng dụng do Bên A cung cấp.
                </li>
              </ul>
            </li>
          </ul>
          <ul v-if="existOnlyVietQr">
            <li>
              Loại QRCode có thể được bổ sung/ thay đổi trong tương lai, khi có sự bổ sung/ thay
              đổi, Bên A sẽ thông báo cho Bên B bằng email hoặc bằng văn bản.
            </li>
            <li>
              Chỉ có các giao dịch khách hàng đã thanh toán và được ghi nhận thành công trên hệ
              thống ứng dụng dành cho điểm bán hàng của Bên A mới được tiến hành đối soát và thanh
              toán.
            </li>
            <li>
              Bên B chỉ được phép chấp nhận các giao dịch thanh toán được thực hiện trên lãnh thổ
              Việt Nam, tuân thủ quy định của Pháp luật, thực hiện đầy đủ các thủ tục xin cấp
              phép/thông báo/đăng ký trong quá trình hoạt động kinh doanh với cơ quan nhà nước có
              thẩm quyền.
            </li>
            <li>
              Bên B chỉ được thực hiện thanh toán qua Phương thức thanh toán bằng QRCode của Bên A
              đối với lĩnh vực kinh doanh đã đăng ký với Bên A theo phụ lục hợp đồng này. Nếu Bên B
              có bất kỳ sự thay đổi nào về lĩnh vực kinh doanh, phải có nghĩa vụ thông báo bằng văn
              bản hoặc các hình thức khác (được bên A chấp nhận) với Bên A trước 15 (mười lăm) ngày
              kể từ ngày kể từ ngày có sự thay đổi.
            </li>
            <li>
              Bên B không thu thêm bất kỳ một khoản phí nào, không tăng giá hàng hoá dịch vụ đối với
              các giao dịch thanh toán bằng QRCode do Bên A cung cấp so với các hình thức thanh toán
              khác và/hoặc các nhà cung cấp dịch vụ thanh toán bằng QRCode khác, đối tượng Khách
              hàng khác. Nếu Bên A, Khách hàng hoặc bất kỳ bên thứ ba nào có bằng chứng về việc làm
              này thì Bên A sẽ có quyền truy đòi Bên B khoản tiền thu thêm, đồng thời phạt vi phạm
              hợp đồng đối với Bên B một khoản bằng 8% giá trị nghĩa vụ bị vi phạm. Khoản tiền truy
              đòi và phạt vi phạm (nếu có) sẽ được yêu cầu thanh toán trực tiếp trong thời hạn 03
              (ba) ngày kể từ ngày có thông báo của Bên A hoặc khấu trừ trực tiếp vào khoản thanh
              toán của Bên B.
            </li>
            <li>
              Bên B chỉ được thực hiện việc chấp nhận thanh toán qua Phương thức thanh toán bằng
              QRCode của Bên A, không được phép cung cấp hoặc nhận thanh toán hộ cho một Bên khác.
            </li>
            <li>
              Các chính sách, quy định áp dụng riêng với phương thức thanh toán VietQR:
              <ul class="form-style2">
                <li>
                  Hình thức nhận thanh toán trực tiếp về số tài khoản Ngân hàng của Bên B
                  <ul class="form-style2">
                    <li>
                      Sau khi giao dịch được xử lý thành công, số tiền thanh toán sẽ được ghi có
                      trực tiếp về số tài khoản Ngân hàng của Bên B đã khai báo và liên kết thông
                      báo trên ứng dụng của Bên A.
                    </li>
                    <li>
                      Bên B đăng nhập vào tài khoản ngân hàng của mình theo dõi biến động số dư hoặc
                      vào ứng dụng Tingbox.vn để theo dõi giao dịch.
                    </li>
                    <li>
                      Hình thức chỉ áp dụng đối với giao dịch VietQR trên ứng dụng Tingbox.vn.
                    </li>
                    <li>
                      Bên A sẽ không tiến hành thanh toán bất cứ khoản tiền nào cho Bên B khi chọn
                      hình thức nhận tiền thanh toán trực tiếp về tài khoản Ngân hàng của Bên B.
                    </li>
                  </ul>
                </li>
                <li>
                  Hình thức nhận thanh toán gián tiếp qua hệ thống của Bên A
                  <ul class="form-style2">
                    <li>
                      Sau khi giao dịch được xử lý thành công trên hệ thống của Bên A, Bên A sẽ tiến
                      hành thanh toán đến Bên B bằng hình thức chuyển khoản tới số tài khoản Ngân
                      hàng của Bên B đã khai báo với Bên A.
                    </li>
                  </ul>
                </li>
                <li>
                  Chu kì thanh toán tiền mặc định: Gọi T là ngày Bên B thực hiện giao dịch VietQR,
                  thì:
                  <ul class="form-style2">
                    <li>
                      Đối với các giao dịch của Bên B phát sinh trên hệ thống của Bên A từ thứ 2 đến
                      thứ 6: thanh toán tiền vào ngày T+1
                    </li>
                    <li>
                      Đối với các giao dịch của Bên B phát sinh trên hệ thống của Bên A vào thứ 7 và
                      Chủ nhật: thanh toán tiền vào ngày thứ 2 của tuần kế tiếp.
                    </li>
                  </ul>
                </li>
                <li>
                  Chính sách nhận tiền nhanh về tài khoản ngân hàng:
                  <ul class="form-style2">
                    <li>
                      Phạm vi áp dụng: Tính năng nhận tiền nhanh được áp dụng với mức phí nhận tiền
                      nhanh MIỄN PHÍ nếu Bên B đạt các tiêu chí dưới đây:
                      <ul class="form-style2">
                        <!-- <li>Bên B có tổng doanh số thanh toán kênh VietQR <= <b>1.000.000.000VNĐ/ tháng</b>
                            (chu kỳ một tháng được tính theo thời gian từ ngày 25 tháng trước đến ngày 24 tháng
                            sau) tính đến thời điểm đặt lệnh nhận tiền nhanh.</li> -->
                        <li>
                          Bên B chỉ được đặt lệnh nhận tiền nhanh không quá
                          <b>04 (bốn)</b> yêu cầu/ngày và tổng số tiền nhận nhanh không quá
                          <b>100.000.000VNĐ/ ngày</b>. Số tiền giao dịch còn lại trong ngày của Bên
                          B (nếu có) sẽ được Bên A thanh toán vào ngày T+1.
                        </li>
                      </ul>
                    </li>
                    <li>
                      Hình thức đặt lệnh nhận tiền nhanh: Bên B phải cài đặt và đặt lệnh yêu cầu rút
                      tiền nhanh trên ứng dụng mPOS360 (Ứng dụng chuyên dùng cho chủ cửa hàng của
                      Bên A)
                    </li>
                    <li>
                      <p>
                        Khung giờ đặt lệnh Nhận tiền nhanh và thời gian nhận tiền tương ứng như sau:
                      </p>
                      <br />
                      <div class="table-responsive">
                        <table>
                          <thead>
                            <tr class="bg-head">
                              <th class="text-center"><b>Ngày hỗ trợ</b></th>
                              <th class="text-center">
                                <b>Khung giờ đặt lệnh</b>
                              </th>
                              <th class="text-center">
                                <b>Thời gian nhận tiền</b>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr class="text-center">
                              <td rowspan="2" class="text-center">Tất cả ngày trong tuần</td>
                              <td class="text-center">Từ 8h30 đến 21h00</td>
                              <td class="text-center">Trong vòng 10 phút kể từ khi đặt lệnh</td>
                            </tr>
                            <tr class="text-center">
                              <td class="text-center">Sau 21h00</td>
                              <td class="text-center">Từ 8h30 sáng ngày hôm sau</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <li>
              Tại bất kỳ thời điểm nào, Bên B chỉ được lựa chọn và sử dụng một phương thức nhận
              thanh toán. Việc thay đổi phương thức nhận thanh toán phải tuân thủ theo điều kiện và
              quy trình do Bên A quy định.
            </li>
            <li>
              Bên B có trách nhiệm chủ động thiết lập và đăng ký phương thức nhận tiền thông qua tài
              khoản của Bên B trên ứng dụng do Bên A cung cấp.
            </li>
          </ul>
        </li>
        <li>
          <h1>ĐIỀU KHOẢN THI HÀNH</h1>
          <ul class="form-style2">
            <li>
              Phụ lục này là bộ phận không thể tách rời của Hợp đồng và các điều khoản khác của Hợp
              đồng vẫn được giữ nguyên. Các bên cam kết tuân thủ các quy định trong phụ lục Hợp đồng
              này.
            </li>
            <li>
              Phụ lục này có hiệu lực kể từ ngày đại diện có thẩm quyền của hai Bên tham gia ký kết.
              Thời hạn hiệu lực của Phụ lục này được xác định theo thời hạn hiệu lực của Hợp đồng
              nêu trên trừ khi hai bên có thỏa thuận khác bằng văn bản.
            </li>
            <li>
              Phụ lục này được lập thành 02 (hai) bản có nội dung và giá trị pháp lý như nhau, mỗi
              Bên giữ 01 (một) bản.
            </li>
          </ul>
        </li>
      </ol>
      <Footer
        v-if="!checkCreatedDateNganluong(dataAppendix)"
        :dataContract="dataContract"
        :dataAppendix="dataAppendix"
        :isAppendix="true"
      ></Footer>
      <FooterNL
        v-else
        :dataContract="dataContract"
        :dataAppendix="dataAppendix"
        :isAppendix="true"
      ></FooterNL>
    </div>
  </div>
</template>

<script>
  import Header from '../block/header.vue'
  import Footer from '../block/footer.vue'
  import HeaderNL from '../block/headerNL.vue'
  import FooterNL from '../block/footerNL.vue'
  export default {
    props: ['dataContract', 'appendix'],
    components: {
      Header,
      Footer,
      HeaderNL,
      FooterNL,
    },
    data() {
      return {}
    },
    computed: {
      customerInfo() {
        return this.dataContract.customerInfoRes ?? this.dataContract.customerInfoCommon ?? {}
      },
      dataAppendix() {
        return (
          this.appendix ?? this.dataContract.lstAppendixTrans.find(e => e.isCreatedWithContract)
        )
      },
      filteredItems() {
        return this.dataAppendix.appendixFeeTrans &&
          this.dataAppendix.appendixFeeTrans.feeCardAndPayment.length > 0
          ? this.dataAppendix.appendixFeeTrans.feeCardAndPayment
          : []
      },
      existOnlyVietQr() {
        return !!(
          this.filteredItems.length === 1 &&
          this.filteredItems.find(s => s.issuerName === 'QRCode VIETQR')
        )
      },
      existOnlyCard() {
        return !!(
          this.filteredItems.length > 0 &&
          this.filteredItems.filter(s => s.paymentMethod === 'CARD').length > 0
        )
      },
    },
    methods: {
      getFee(issuerName, paymentMethod, defaultFee) {
        return `${
          this.dataAppendix.appendixFeeTrans?.feeCardAndPayment?.find(
            s => s.issuerName === issuerName && s.paymentMethod === paymentMethod
          )?.feePerTransaction ?? defaultFee
        } %`
      },
    },
  }
</script>

<style scoped src="@/assets/css/style-review.css"></style>
